import React, { useEffect } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import Carousel from 'react-bootstrap/Carousel';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';

import Padding from '../layout/Padding.jsx';

const Announcements = () => {
  const [res, req] = useHttpStatus();

  useEffect(() => {
    req({
      url: 'api/site/announcements',
      params: {
        limit: 6,
        sort: { publishAt: -1 },
        filter: { frontpage: true, path: 'app' },
      },
    });
  }, []);

  const renderSlide = (row) => (
    <div className="row no-gutters align-items-center">
      <div className="col-12 col-lg">
        <Padding className="py-4">
          <div className="row my-4 align-items-center">
            <div className="col-auto pr-2">
              <img
                src={'assets/img/announce.svg'}
                style={{ width: '20px' }}
              />
            </div>
            <div className="col p-0">
              <Link to="/app/announcements">
                <h4 className="m-0">比賽提示</h4>
              </Link>
            </div>
            <div className="col-auto">
              <Link to="/app/announcements">
                查看全部
              </Link>
            </div>
          </div>
          <Link to={`/app/announcements/${row._id}`}>
            <h5 className="my-4">{row.title}</h5>
          </Link>
          <p className="small text-muted">
            發布日期: {moment(row.publishAt).format('LL')}
          </p>
        </Padding>
      </div>
      <div
        className="col-12 col-lg ratio-ultrawide"
        style={{ maxHeight: '360px' }}
      >
        <Link to={`/app/announcements/${row._id}`}>
          <div
            className="img-bg-cover"
            style={{ backgroundImage: `url('${row.coverImg}')` }}
          ></div>
        </Link>
      </div>
    </div>
  );

  return (
    <PageHttp res={res}>
      {({ rows }) => (rows.length ? (
        <Carousel
          controls={false}
          fade={true}
        >
          {rows.map((row, i) => (
            <Carousel.Item key={i}>
              {renderSlide(row)}
            </Carousel.Item>
          ))}
        </Carousel>
      ) : '')}
    </PageHttp>
  );
};

export default Announcements;
